import { render, staticRenderFns } from "./pindaan-b.vue?vue&type=template&id=b9e2a8dc&"
import script from "./pindaan-b.vue?vue&type=script&lang=js&"
export * from "./pindaan-b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports